import { ComponentType, useContext } from "react";
import { TriggerContext, TriggerContextType } from "../../Context/TriggerContext";


interface contextProps {
  context:TriggerContextType|undefined ;
}

export type WithContextProps<T> = T & contextProps;
type OmitContext<T> = Omit<T, keyof contextProps>;

export function withContextComponent<T>(
  Component: ComponentType<OmitContext<T> & contextProps>
) {
  // eslint-disable-next-line react/display-name
  return (props: OmitContext<T>) => {
    
    const context=useContext(TriggerContext);
    return (
      <Component
       context={context}
        {...props}
      />
    );
  };
}